import { FC } from 'react';

import Link from 'next/link';

import SectionLead from '@components_iqfu/public/section_lead/SectionLead';

import styles from './PrivacyContent.module.scss';

const PrivacyContent: FC = () => {
  return (
    <>
      <div className={styles.head_title}>
        <SectionLead>プライバシーポリシー</SectionLead>
      </div>
      イクラ株式会社（以下「当社」といいます。）にて提供する「イクラ不動産」(以下「本サイト」といいます。)は、個人情報の保護、適正な管理が重要な社会的責務であることを認識し、個人情報の適正な取扱いと保護に努めます。
      <div className={styles.title}>個人情報の定義</div>
      本プライバシーポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます。）又は個人識別符号が含まれるものを意味するものとします。
      {/* end of section */}
      <div className={styles.title}>個人情報の収集、および利用目的</div>
      個人情報の収集は、適正な手段によって行うとともに、利用目的の公表、通知、明示等を行い、本人の同意なく、利用目的の範囲を超えた個人情報の取扱いをいたしません。また、本サイトを経由してお預かりした個人情報に、本人から直接または間接的に取得した補足情報についても本プライバシーポリシーに従います。
      <br />
      <br />
      本サイト利用者（以下「利用者」といいます。）の個人情報は、以下のとおりの目的に利用いたします。なお、当社は、個人情報の利用目的と相当の関連性を有すると合理的に認められる範囲内において変更することがあり、変更した場合には利用者に通知又は公表します。
      <div className={styles.paragraph_text}>
        <div className={styles.paragraph_mark} /> 利用目的
      </div>
      <ul className={styles.policy_list}>
        <li className={styles.policy_list__item}>
          利用者が選択した提携不動産会社から、不動産仲介サービスを提供するため
        </li>
        <li className={styles.policy_list__item}>当社が利用者に適した提携不動産会社を紹介するため</li>
        <li className={styles.policy_list__item}>当社のサービスの利便性向上のため</li>
        <li className={styles.policy_list__item}>当社及び提携企業のサービスに関する会員のご意見をお伺いするため</li>
        <li className={styles.policy_list__item}>当社及び提携企業のサービスご利用時の本人確認のため</li>
        <li className={styles.policy_list__item}>当社及び提携企業のサービスに関するお問合せへの対応、回答のため</li>
        <li className={styles.policy_list__item}>当社及び提携企業のサービスに関するアンケート調査実施のため</li>
        <li className={styles.policy_list__item}>懸賞等の当選通知、賞品お届けのため</li>
        <li className={styles.policy_list__item}>当社サービスの拡充、改善、新規開発のための調査・分析のため</li>
        <li className={styles.policy_list__item}>
          ご請求に対する対応、提供させて頂くサービスのカスタマイズ、サービスの向上、利用者との連絡のため
        </li>
        <li className={styles.policy_list__item}>
          年齢や性別、居住地といったユーザー属性が特定できない統計情報に変換した上、当社の協力企業となりうる企業、広告主、その他の第三者への当社サービスの説明、その他合法的な目的のために利用、開示させていただくため
        </li>
      </ul>
      {/* end of section */}
      <div className={styles.title}>個人情報の第三者への提供</div>
      当社は、以下の場合を除き、あらかじめ利用者の同意を得ずに利用者の個人情報を第三者に提供しません。
      <ul className={styles.policy_list}>
        <li className={styles.policy_list__item}>法令の規定に基づく場合又は法令により認められる場合。</li>
        <li className={styles.policy_list__item}>
          人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき。
        </li>
        <li className={styles.policy_list__item}>
          公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき。
        </li>
        <li className={styles.policy_list__item}>
          国の機関もしくは地方公共団体はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき。
        </li>
        <li className={styles.policy_list__item}>
          「2.個人情報の収集、および利用目的に定める目的」の達成に必要な範囲内において個人情報の取扱いを委託することに伴って提供する場合（司法書士、土地家屋調査士、金融機関、不動産管理会社、不動産調査機関、配送業者など）
        </li>
        <li className={styles.policy_list__item}>「4.共同利用」に記載の共同利用のために提供する場合</li>
        <li className={styles.policy_list__item}>
          当社は、「2.個人情報の収集、および利用目的に定める目的」第1号から11号に関連する業務及び当該業務に付帯する業務を行うに際し、(a)に定める個人情報を、(b)に定める方法により取得し、(c)の方法で(d)に掲げる第三者に対し提供することがあります。本人からの申出により、第三者への提供は停止いたします。
          <ul className={styles.policy_list}>
            <li className={styles.policy_list__insideItem}>
              (a) 第三者に提供される個人情報の項目
              <br />
              ⅰ．個人を特定する情報（氏名、連絡先住所、生年月日）
              <br />
              ⅱ．電話番号
              <br />
              ⅲ．メールアドレス
              <br />
              ⅳ．物件情報（住所、建物面積、土地面積、間取り、築年、及びその名義）
              <br />
              ⅴ．その他当社が定める入力フォームにユーザーが入力する情報
              <br />
              ⅵ．その他当社がユーザーへの電話連絡時にヒアリングする情報
              <br />
              ⅶ．Cookie
              <br />
              ⅷ．ログ
            </li>
            <li className={styles.policy_list__insideItem}>
              (b) 第三者に提供される個人情報の取得方法 <br />
              利用者が本ウェブサイトにて入力する方法（会員登録、物件情報登録）、利用者が電話にて当社へ問い合わせた際にヒアリングする方法、利用者が当社の提供するチャットシステムで当社とやり取りする方法
            </li>
            <li className={styles.policy_list__insideItem}>
              (c) 第三者への提供方法
              <br />
              書面、郵便物、電話、インターネット、電子メール、広告媒体等
            </li>
            <li className={styles.policy_list__insideItem}>(d) 提供される第三者の範囲</li>
            <div className={styles.indent_wrapper}>
              ⅰ．利用者が指定した提携不動産会社。ただし、提携不動産会社からその業務提携先（販売会社、フランチャイズ・ボランタリーチェーン等の加盟店、サービス提供企業等）に再提供される場合があります
              <br />
              ⅱ．利用者の求めに応じて、当社が紹介する提携不動産会社及びその紹介候補
              <br />
              ⅲ．指定流通機構（物件登録、成約通知）
            </div>
            <li className={styles.policy_list__insideItem}>(e) 提供項目</li>
            <div className={styles.indent_wrapper}>
              ⅰ．会員登録や物件登録により入力、又は電話等にてご提供いただいた項目（アンケートやヒアリングにより知り得た情報を含む）
            </div>
          </ul>
        </li>
      </ul>
      {/* end of section */}
      <div className={styles.title}>共同利用</div>
      当社は、以下のとおり個人情報を共同利用いたします。
      <ul className={styles.policy_list}>
        <li className={styles.policy_list__insideItem}>
          (1) 共同して利用される個人情報の項目
          <br />
          氏名、連絡先、住所、生年月日、電話番号、職業、マンションその他の物件の取引に関する情報
        </li>
        <li className={styles.policy_list__insideItem}>
          (2) 共同して利用する者の範囲
          <br />
          当社の提携先
        </li>
        <li className={styles.policy_list__insideItem}>
          (3) 利用する者の利用目的
          <br />
          上記「2.個人情報の収集、および利用目的に定める目的」に定める目的
        </li>
        <li className={styles.policy_list__insideItem}>
          (4) 上記個人情報の管理について責任を有する者の氏名
          <br />
          〒532-0001 大阪府大阪市淀川区西中島1-9-20
          <br />
          イクラ株式会社
          <br />
          代表取締役 坂根大介
        </li>
      </ul>
      {/* end of section */}
      <div className={styles.title}>個人情報の安全管理措置</div>
      <ul className={styles.policy_list}>
        <li className={styles.policy_list__item}>
          利用者の個人情報については適正かつ慎重に管理いたします。個人情報への不正アクセス、紛失、改ざん、漏えい等を防止するため、必要かつ適切な以下の安全管理措置を講じます。
        </li>
        <div className={styles.table_container}>
          <table className={styles.table}>
            <tr>
              <th>基本方針の策定</th>
              <td>
                個人データの適正な取扱いの確保のため、「関係法令・ガイドライン等の遵守」、「質問及び苦情処理の窓口」等についての基本方針として、本プライバシーポリシーを策定
              </td>
            </tr>
            <tr>
              <th>個人データの取扱いに係る規律の整備</th>
              <td>
                取得、利用、保存、提供、削除・廃棄等の段階ごとに、取扱方法、責任者・担当者及びその任務等について個人データの取扱規程を策定
              </td>
            </tr>
            <tr>
              <th>組織的安全管理措置</th>
              <td>
                <ul className={styles.policy_list}>
                  <li className={styles.policy_list__item}>
                    個人データの取扱いに関する責任者を設置するとともに、個人データを取り扱う従業者及び当該従業者が取り扱う個人データの範囲を明確化し、法や取扱規程に違反している事実又は兆候を把握した場合の責任者への報告連絡体制を整備
                  </li>
                  <li className={styles.policy_list__item}>
                    個人データの取扱状況について、定期的に自己点検を実施するとともに、他部署や外部の者による監査を実施
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>人的安全管理措置</th>
              <td>
                <ul className={styles.policy_list}>
                  <li className={styles.policy_list__item}>
                    個人データの取扱いに関する留意事項について、従業者に定期的な研修を実施
                  </li>
                  <li className={styles.policy_list__item}>個人データについての秘密保持に関する事項を就業規則に記載</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>物理的安全管理措置</th>
              <td>
                <ul className={styles.policy_list}>
                  <li className={styles.policy_list__item}>
                    個人データを取り扱う区域において、従業者の入退室管理及び持ち込む機器等の制限を行うとともに、権限を有しない者による個人データの閲覧を防止する措置を実施{' '}
                  </li>
                  <li className={styles.policy_list__item}>
                    個人データを取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するための措置を講じるとともに、事業所内の移動を含め、当該機器、電子媒体等を持ち運ぶ場合、容易に個人データが判明しないよう措置を実施
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>技術的安全管理措置</th>
              <td>
                <ul className={styles.policy_list}>
                  <li className={styles.policy_list__item}>
                    アクセス制御を実施して、担当者及び取り扱う個人情報データベース等の範囲を限定
                  </li>
                  <li className={styles.policy_list__item}>
                    個人データを取り扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>外的環境の把握</th>
              <td>
                個人データを保管しているアメリカ合衆国における個人情報の保護に関する制度を把握した上で安全管理措置を実施
              </td>
            </tr>
          </table>
        </div>
        <li className={styles.policy_list__item}>
          当社は、当社の取り扱う個人情報の漏洩、滅失、毀損等の事態が生じた場合において、個人情報保護法の定めに基づき個人情報保護委員会への報告及び本人への通知を要する場合には、かかる報告及び通知を行います。
        </li>
      </ul>
      {/* end of section */}
      <div className={styles.title}>SSL暗号化通信</div>
      本サイトにて個人情報をご提供いただく場合は、SSL暗号化通信を利用して安全に行っていただけます。なお、利用者の利用環境（ブラウザーの設定、インターネット接続環境）によっては、SSL暗号化通信をご利用いただけない場合がございます。
      {/* end of section */}
      <div className={styles.title}>アクセスログ</div>
      本サイトでは、アクセスされた方の情報をアクセスログという形で記録しています。アクセスログには、アクセスされた方のIPアドレス、ブラウザーの種類、ドメイン名、アクセス時間、アクセス回数などが含まれます。アクセスログは、本サイトの保守管理・運用や利用状況に関する統計分析、およびサービス改善のための参考として利用いたします。
      {/* end of section */}
      <div className={styles.title}>クッキー（Cookie）</div>
      本サイトでは、サービス改善、統計情報の収集等のために、クッキー（Cookie）を使用しております。Cookie
      とは、利用者が本サイトに訪問したときに、サーバーが利用者のパソコン等にデータを送るために利用する小さなデータファイルで、サービスを充実させ、本サイトをより便利に利用していただくために使用しています。本サイトでは、Cookieを用いて収集される、利用者が閲覧したページに関する情報を、個人を識別する情報と組み合せ、利用者の情報として利用する場合があります。また、本サイトでは、第三者が提供する広告システムおよびレコメンドサービスを利用するために、当該第三者のCookieを発信する場合があります。本サイトでは上記利用を目的として、
      <Link href={`https://btoptout.yahoo.co.jp/optout/index.html`} className={styles.link_text}>
        Yahoo株式会社
      </Link>
      ・
      <Link href={`https://policies.google.com/technologies/ads?hl=ja`} className={styles.link_text}>
        グーグル合同会社
      </Link>
      （
      <Link href={`https://marketingplatform.google.com/about/analytics/terms/jp/`} className={styles.link_text}>
        Google Analytics
      </Link>
      を含む。Google
      Analyticsでデータが収集、処理される仕組みについては「利用者がGoogleパートナーのサイトやアプリを使用する際のGoogleによるデータ使用」のページ(
      <Link href={`https://www.google.com/intl/ja/policies/privacy/partners`} className={styles.link_text}>
        https://www.google.com/intl/ja/policies/privacy/partners
      </Link>
      )参照）から提供されるCookieを使用しています。利用者は、Cookieを受け取る際に警告を表示するようにブラウザーを設定することにより、Cookieを受け取るか否かを決めることができます。Cookieを拒否した場合には、本サイトのサービスの一部が利用できない場合がございます。Cookieを利用することによって、本サイトの機能をより便利に利用していただくことが出来るようになるため、Cookieを受け取る設定にしておくことをおすすめいたします。また、利用者の利用環境（ブラウザーの設定、インターネット接続環境）によっては、Cookieを拒否できない場合がございます。
      {/* end of section */}
      <div className={styles.title}>Webビーコンの利用</div>
      Webビーコン（クリアGIFと呼ばれることもあります）は、ウェブページやHTML形式の電子メールに埋め込まれた微小な電子画像のことです。本サイトでは、Webビーコンを用いて収集される、利用者の閲覧情報を、個人を識別する情報と組み合せ、利用者の情報として利用する場合があります。これらの情報は、利用者に合わせてより的確な情報提供の実施、サービス改善、統計情報として集計する目的で利用いたします。
      {/* end of section */}
      <div className={styles.title}>個別URLの利用</div>
      利用者にお届けするご案内メールには、利用者を識別する暗号化されたパラメータ付きのURL（個別URL）をご案内するものがあります。本サイトでは、個別URLを用いて収集される利用者の閲覧情報を収集し、利用者の情報として利用する場合があります。これらの情報は、利用者に合わせてより的確な情報提供の実施、サービス改善、統計情報として集計する目的で利用いたします。
      {/* end of section */}
      <div className={styles.title}>他サイトへのリンク</div>
      本サイトよりリンク（バナー広告、コンテンツ提供によるリンクを含みます）を設定している他のサイトでの個人情報の取扱いについては、当社では責任を負うことができません。本サイトより他のサイトに移動される場合には、各リンク先サイトの個人情報保護方針等をご覧になることをお勧めいたします。
      {/* end of section */}
      <div className={styles.title}>個人情報の取扱いの委託</div>
      利用者の個人情報について、その取扱いを外部に委託する場合があります。その場合は、個人情報の保護に十分な措置を講じている者を選定し、委託先に対し、必要かつ適切な監督を行います。
      {/* end of section */}
      <div className={styles.title}>個人情報の開示・訂正等の手続き</div>
      利用者の個人情報の開示、訂正、追加または削除、利用停止または消去、ならびに第三者への提供の停止のご請求（以下「個人情報の開示等の請求」といいます。）については、個人情報保護法に定める範囲において、当社が別途定める手続きによって、遅滞無く対応させていただきます。なお、サービスに定める所定の手続きに従い、本人自身で、お手続きいただくことができるものもございます。
      個人情報の開示等の請求の手続きについては、後記お問い合わせ窓口にご連絡ください。
      {/* end of section */}
      <div className={styles.title}>個人関連情報の第三者提供</div>
      <ul className={styles.policy_list}>
        <li className={styles.policy_list__item}>
          当社は、第三者が個人関連情報（個人情報保護法第2条第7項に定めるものを意味し、同法第16条第7項に定める個人関連情報データベース等を構成するものに限ります。以下同じ。）を個人データとして取得することが想定されるときは、「3.
          個人情報の第三者への提供」第(2)号から第(6)号に掲げる場合を除くほか、次に掲げる事項について、あらかじめ個人情報保護委員会規則で定めるところにより確認することをしないで、当該個人関連情報を当該第三者に提供しません。
        </li>
        <ul className={styles.policy_list}>
          <li className={styles.policy_list__insideItem}>
            (a)
            当該第三者が当社から個人関連情報の提供を受けて本人が識別される個人データとして取得することを認める旨の本人の同意が得られていること。
          </li>
          <li className={styles.policy_list__insideItem}>
            (b)
            外国にある第三者への提供にあっては、前号の本人の同意を得ようとする場合において、個人情報保護委員会規則で定めるところにより、あらかじめ、当該外国における個人情報の保護に関する制度、当該第三者が講ずる個人情報の保護のための措置その他本人に参考となるべき情報が本人に提供されていること。
          </li>
        </ul>
        <li className={styles.policy_list__item}>
          当社は、個人関連情報を第三者に提供したときは、個人情報保護法第31条に従い、記録の作成及び保存を行います。
        </li>
        <li className={styles.policy_list__item}>
          当社は、第三者から個人関連情報の提供を受けるに際しては、個人情報保護法第31条に従い、必要な確認を行い、当該確認にかかる記録の作成及び保存を行うものとします。
        </li>
      </ul>
      {/* end of section */}
      <div className={styles.title}>仮名加工情報の取扱い</div>
      <ul className={styles.policy_list}>
        <li className={styles.policy_list__item}>
          当社は、仮名加工情報（個人情報保護法第2条第5項に定めるものを意味し、同法第16条第5項に定める仮名加工情報データベース等を構成するものに限ります。以下同じ。）を作成するときは、個人情報保護委員会規則で定める基準に従い、個人情報を加工するものとします。
        </li>
        <li className={styles.policy_list__item}>
          当社は、仮名加工情報を作成したとき、又は仮名加工情報及び当該仮名加工情報に係る削除情報等（個人情報保護法第41条第2項に定めるものを意味します。以下同じ。）を取得したときは、削除情報等の漏えいを防止するために必要なものとして個人情報保護委員会規則で定める基準に従い、削除情報等の安全管理のための措置を講じるものとします。
        </li>
        <li className={styles.policy_list__item}>
          当社は、法令に基づく場合を除くほか、利用目的の達成に必要な範囲を超えて、仮名加工情報(個人情報であるものに限ります。以下、本第(3)号から第(5)号までにおいて同じ。)を取り扱いません。
        </li>
        <li className={styles.policy_list__item}>
          仮名加工情報についての「2.個人情報の収集、および利用目的に定める目的」柱書第4文の適用については、「個人情報の利用目的と相当の関連性を有すると合理的に認められる範囲内において変更する」とあるのは「利用目的を変更する」と、「通知又は公表します」とあるのは「公表します」と、それぞれ読み替えるものとします。
        </li>
        <li className={styles.policy_list__item}>
          仮名加工情報については、「13. 個人情報の開示・訂正等の手続き」を適用しないものとします。
        </li>
        <li className={styles.policy_list__item}>
          当社は、「3.
          個人情報の第三者への提供」の規定にかかわらず、法令に基づく場合を除くほか、仮名加工情報（個人情報であるか否かを問いません。）である個人データを第三者に提供しません。但し、「3.
          個人情報の第三者への提供」第(2)号から第(6)号に掲げる場合は上記に定める第三者への提供には該当しません。
        </li>
      </ul>
      {/* end of section */}
      <div className={styles.title}>プライバシーポリシーの改訂</div>
      利用者の個人情報の取扱いにつきましては、法令等の要請や個人情報保護の一層の改善のため、適宜、見直し、改訂することがございます。改訂に際しては、本サイトに一定期間掲載し利用者に通知させていただきます。
      {/* end of section */}
      <div className={styles.title}>個人情報のお問い合わせ</div>
      本サイトの個人情報の取扱いに関するご意見、ご質問等はこちらまでご連絡ください。
      {/* end of section */}
      <div className={styles.title}>お問い合わせ窓口</div>
      <ul className={styles.policy_list}>
        <li className={styles.policy_list__item}>
          個人情報取扱事業者の名称、住所及び代表者氏名
          <br />
          〒532-0001 大阪府大阪市淀川区西中島1-9-20
          <br />
          イクラ株式会社
          <br />
          代表取締役 坂根大介
        </li>
        <li className={styles.policy_list__item}>
          問い合わせ窓口
          <a className={styles.link_text} href="mailto:info@iqra.co.jp">
            info@iqra.co.jp
          </a>
        </li>
      </ul>
      <div className={styles.revised_date}>
        【2019年9月1日制定】
        <br />
        【2020年10月24日改定】
        <br />
        【2022年10月17日改定】
        <br />
        【2023年1月18日改定】
      </div>
    </>
  );
};

export default PrivacyContent;
